import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { store } from 'services'
import { getUserProfile } from 'app/selectors'
import { confirmVerificationCodeSuccessSelector } from 'app/selectors/user'

import { Button, ReactCodeInput } from 'controls'
import GeneralFeedback from 'components/Feedback'
import { Card } from 'components'
import { companyConfig } from 'globalConfigApp'

import { CODE_VERIFICATION_TYPES } from './constants'
import { codeVerificationStyles, sendCodeVerificationStyles } from './styles'

const CODE_SIZE = 6

const CODE_ERRORS = {
  'Code expired': 'Tu código expiró. Solicita otro e intenta de nuevo.',
}

const CodeVerification = ({
  codeVerificationType = CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE,
}) => {
  const dispatch = useDispatch()
  const { email } = useSelector(getUserProfile)
  const [codeSent, setCodeSent] = useState(false)

  const sendCodeFeedback = useSelector(
    store.sendVerificationCode('user').selector,
  )
  const confirmCodeFeedback = useSelector(
    store.confirmVerificationCode('user').selector,
  )
  const confirmSuccess = useSelector(confirmVerificationCodeSuccessSelector)

  function sendVerificationCode() {
    dispatch(
      store.sendVerificationCode('user').action(codeVerificationType, email),
    )
    dispatch(store.confirmVerificationCode('user').clear())
  }

  function sendCode() {
    sendVerificationCode()
    setCodeSent(true)
  }

  useEffect(() => {
    return () => {
      dispatch(store.sendVerificationCode('user').clear())
      dispatch(store.confirmVerificationCode('user').clear())
    }
  }, [])

  const verifyCode = code => {
    if (code && code.length === CODE_SIZE) {
      dispatch(
        store
          .confirmVerificationCode('user')
          .action(codeVerificationType, code, email),
      )
    }
  }

  if (confirmSuccess) {
    return (
      <Card success small rounded>
        Código confirmado, ahora puedes registrar esta sesión.
      </Card>
    )
  }

  if (!codeSent) {
    return (
      <div
        data-qa="send-code-verification"
        className="send-code-verification-message"
      >
        {codeVerificationType === CODE_VERIFICATION_TYPES.NEW_LOGIN_DEVICE && (
          <p>
            <strong>Verifica que esta sesión te pertenece</strong>
          </p>
        )}

        <p>
          Enviar código de verificación a <strong>{email}</strong>:
        </p>

        <div className="send-code-button-container form-input-margin">
          <Button
            onClick={sendCode}
            size="large"
            color="primary"
            className="send-code-button"
          >
            Enviar
          </Button>
        </div>

        <style jsx>{sendCodeVerificationStyles}</style>
      </div>
    )
  }

  if (
    sendCodeFeedback.loading ||
    sendCodeFeedback.error ||
    sendCodeFeedback.error ||
    !Boolean(sendCodeFeedback.response)
  ) {
    return <GeneralFeedback {...sendCodeFeedback} />
  }

  return (
    <div data-qa="code-verification" className="code-verification">
      <p className="code-verification-message">
        {companyConfig.name} te acaba de enviar un email a <strong>{email}</strong> con un
        código de verificación. Ingresalo a continuación:
      </p>

      <div style={{ margin: '0 auto', width: 'fit-content' }}>
        <ReactCodeInput
          className="form-input-margin"
          name="code"
          type="number"
          fields={CODE_SIZE}
          onChange={verifyCode}
        />
      </div>

      <GeneralFeedback
        {...confirmCodeFeedback}
        messageError={
          CODE_ERRORS[confirmCodeFeedback?.error?.detail] ||
          'Error en tu código, solicita otro e intenta de nuevo.'
        }
      />

      <style jsx>{codeVerificationStyles}</style>
    </div>
  )
}

export default CodeVerification
